import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";
import { WorkOrderConcessionTypeSchema } from "@remi/enums/work-order-concession/type";

const ApproveWorkOrderConcessionDecisionSchema = z.object({
  decisionKey: z.string(),
  concessionId: z.string(),
  concessionType: WorkOrderConcessionTypeSchema,
  proposedAmountCents: z.number().int(),
  decision: z.enum(["APPROVED", "REJECTED", "WITHDRAWN"]),
  approvedAmountCents: z.number().int().nullable(),
  appliedWorkOrderId: z.number().int().nullable(),
  financeNote: z.string().nullable(),
});

export const ApproveWorkOrderConcessionTaskAttemptSchema = z.object({
  type: z.literal(TaskType.APPROVE_WORK_ORDER_CONCESSION),
  // Optional: completions before decisions were recorded wrote a bare `{ type }` row for this task.
  decided: ApproveWorkOrderConcessionDecisionSchema.optional(),
});

export type ApproveWorkOrderConcessionTaskAttempt = z.infer<typeof ApproveWorkOrderConcessionTaskAttemptSchema>;
